module.exports = __webpack_public_path__ + "media/images/menu/ceres-6afe503a96a6ec24325dda0f068844f8.jpg";